export default {
    'setTabSelect'(context, isTabSelect) {
        context.commit('tabSelect', isTabSelect)
    },
    'setListTab'(context, isListTab) {
        context.commit('listTab', isListTab)
    },
};
